import { render, staticRenderFns } from "./CampanhaMetas.vue?vue&type=template&id=ed1469d2&scoped=true"
import script from "./CampanhaMetas.vue?vue&type=script&lang=js"
export * from "./CampanhaMetas.vue?vue&type=script&lang=js"
import style0 from "./CampanhaMetas.vue?vue&type=style&index=0&id=ed1469d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed1469d2",
  null
  
)

export default component.exports